import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import CollapsibleContainer from '../../components/CollapsibleContainer';
import UpperContainer from '../../components/UpperContainer';
import ButtonContainer from '../../components/ButtonContainer';
import { animateToScreen as animateToScreenAction } from '../../redux/ui/actions';
import TextColumnContent from '../../molecules/TextColumnContent';
import BackButtonContainer from '../../molecules/BackButtonContainer';
import { H2, Text } from '../../components/Typography';
import Title from '../../components/Title';
import Description from '../../components/Description';
import Button from '../../components/Button';

class AdditionalZoneConfirmationTexts extends PureComponent {
  render() {
    const { animateToScreen, t } = this.props;
    return (
      <>
        <BackButtonContainer
          home={t('Generic.breadcrumbHome')}
          homeLink={t('Generic.breadcrumbHomeLink')}
          secondaryHome={t('Generic.breadcrumbSecondaryHome')}
          secondaryHomeLink={t('Generic.breadcrumbSecondaryHomeLink')}
          textPrev={t('Flows.home')}
          text={t('Flows.additionalZone')}
          onClick={() => animateToScreen('Home')}
        />
        <TextColumnContent paddingTop={-100}>
          <Title>
            <H2>
              <Trans i18nKey="AdditionalZoneConfirmation.title" />
            </H2>
          </Title>
          <UpperContainer>
            <Description>
              <Text>
                <Trans i18nKey="AdditionalZoneConfirmation.description" />
              </Text>
            </Description>
            <Button
              onClick={() => animateToScreen('Home')}
              text={t('Generic.backToStart')}
            />
          </UpperContainer>
          <CollapsibleContainer>
            <ButtonContainer>
              <Button
                onClick={() => animateToScreen('Home')}
                text={t('Generic.backToStart')}
              />
            </ButtonContainer>
            <Collapsible
              trigger={t('Generic.additionalInfo')}
              transitionTime={300}
            >
              <Description>
                <Text>
                  <Trans i18nKey="AdditionalZoneConfirmation.description" />
                </Text>
              </Description>
            </Collapsible>
          </CollapsibleContainer>
        </TextColumnContent>
      </>
    );
  }
}

AdditionalZoneConfirmationTexts.propTypes = {
  animateToScreen: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  animateToScreen: (screenName) => dispatch(animateToScreenAction(screenName)),
});

// prettier-ignore
export default connect(null, mapDispatchToProps)(AdditionalZoneConfirmationTexts);
